import { useState, useEffect } from 'react';
import { PolicyIntelDashboard } from '@/components/policy-intel';
import type { PolicyData } from '@/components/policy-intel';
import '@/components/policy-intel/policy-intel.css';

const API_URL = '/api/policy/dashboard';
const FALLBACK_URL = '/data/latest.json';

export default function PolicyDashboard() {
  const [data, setData] = useState<PolicyData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(API_URL)
      .then(r => r.json())
      .then(setData)
      .catch(() => {
        fetch(FALLBACK_URL)
          .then(r => r.json())
          .then(setData)
          .catch(e => setError(e.message));
      });
  }, []);

  if (error) {
    return (
      <div className="pi-loading">
        <h1>RESINSMART</h1>
        <p style={{ color: '#6b7366', fontSize: '0.875rem' }}>Failed to load policy data</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="pi-loading">
        <h1>RESINSMART</h1>
        <div className="pi-spinner" />
      </div>
    );
  }

  return <PolicyIntelDashboard data={data} />;
}
